import { Box, Button, Grid, Typography } from "@mui/material";
import { ArrowForward } from "@mui/icons-material";
import hero1 from "../../assets/finance/1.png";
import CustomText, { textStyles } from "../../components/CustomText";
import { useMediaQuery, } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import more from "../../assets/more.svg";
import CustomButton from "../../components/CustomButton";
import FeaturesHeroCard from "../../components/cards/FeaturesHeroCard";
import hero2 from "../../assets/finance/2.webp";
import hero3 from "../../assets/finance/3.webp";
import hero4 from "../../assets/hero4.webp";
import hero6 from "../../assets/finance/5.png";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import hero2es from "../../assets/spanish/Industry/hero2es.webp";
// import hero4es from "../../assets/spanish/Industry/hero4es.webp";
import hero4estime from "../../assets/spanish/TimeTracking/hero4estime.webp";
import herocard4time from "../../assets/TimeTracking/herocard4time.webp";
import hero5es from "../../assets/spanish/Industry/hero5es.webp"
const FeaturesDesign = () => {
  const { t, i18n } = useTranslation();
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"))
  const hero_section_button_text = {
    main: "var(--Tertiary, #003149)",
    hover: "#00263a",
    contrastText: "#FFFFFF",
    fontSize: "18px",
  }
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

const heroImageSrc = i18n.language === "es" ? hero2es : hero3;

const card1 = i18n.language === "es" ? hero5es : hero2;
const card2 = i18n.language === "es" ? hero4estime : herocard4time;
  return (
    <>
    <Box>
          <CustomText
            style={{
              ...textStyles.h3,
              marginBottom: isMobile ? "0rem" : "2.5rem",
              marginTop: isMobile ? "0rem" : "2.5rem",
              fontSize: isMobile ? "36px" : "42px",
              textAlign: isMobile ? "center" : "center",
            }}
          >
     {t("on_site_features_heading")}
          </CustomText>
        </Box>
      <Box>
    
 <Box
  sx={{
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: 4, // spacing between cards
    px:isMobile?1:8,
  }}
>
  <Box
    sx={{
      flex: { xs: "0 0 100%", md: "0 0 48%", lg: "0 0 31%" }, // responsive widths
      maxWidth: { xs: "100%", md: "48%", lg: "31%" },
    }}
  >
    <FeaturesHeroCard
      bgColor="#FFFFFF"
      image={heroImageSrc}
      imagePosition="top"
    //   title={t('finance_worker_billing_title')}
             title={
        <Box sx={{ fontSize: "30px", fontWeight: 600, lineHeight: "1.2" }}>
       {t('finance_worker_billing_title')}
        </Box>
      }
      description={t('finance_worker_billing_description')}
            sx={{py: { xs: 6, md: 10 }, px: { xs: 2, md: 5, lg: 5 } }}
    />
  </Box>

  <Box
    sx={{
      flex: { xs: "0 0 100%", md: "0 0 48%", lg: "0 0 31%" },
      maxWidth: { xs: "100%", md: "48%", lg: "31%" },
    }}
  >
    <FeaturesHeroCard
      bgColor="#EFF4F8"
      image={card1}
      imagePosition="top"
    //   title={t('finance_payroll_integration_title')}
             title={
        <Box sx={{ fontSize: "30px", fontWeight: 600, lineHeight: "1.2" }}>
     {t('finance_payroll_integration_title')}
        </Box>
      }
      description={t('finance_payroll_integration_description')}
      sx={{py: { xs: 6, md: 10 }, px: { xs: 2, md: 5, lg: 5 } }}
    />
  </Box>

  <Box
    sx={{
      flex: { xs: "0 0 100%", md: "0 0 48%", lg: "0 0 31%" },
      maxWidth: { xs: "100%", md: "48%", lg: "31%" },
    }}
  >
    <FeaturesHeroCard
      bgColor="#FFFFFF"
      image={card2}
      imagePosition="top"
    //   title={t('finance_salary_logs_title')}
            title={
        <Box sx={{ fontSize: "30px", fontWeight: 600, lineHeight: "1.2" }}>
 {t('finance_salary_logs_title')}
        </Box>
      }
      description={t('finance_salary_logs_description')}
            sx={{py: { xs: 6, md: 10 }, px: { xs: 2, md: 5, lg: 5 } }}
    />
  </Box>
</Box>

   

      </Box>
    </>
  );
}
export default FeaturesDesign